import { Sort } from 'components/atoms/Table/table.types';
import useTableQuery from 'hooks/tableQuery/useTableQuery';
import tableState from 'store/tableState/tableState.store';
import { UserCacheKeys } from 'types/cacheKeys.types';
import { getClientInvitations } from 'api/v3/access/workspace';
import { ClientsInvitationStatus } from 'types/organization.types';
import useWorkspaceDetails from 'hooks/useWorkspaceDetails';

const useTableState = tableState({
  filtersData: {},
  tableSorter: { cellId: 'to', direction: Sort.desc },
});

export const useClientPendingInvitationsWithPaging = (): ReturnType<
  typeof useTableQuery
> => {
  const { hasWorkspaceContext, workspaceId } = useWorkspaceDetails();
  const tableState = useTableState();

  return useTableQuery({
    tableState,
    cacheKey: [UserCacheKeys.CustomerInvitations, workspaceId],
    onFetch: (params) =>
      getClientInvitations({
        ...params,
        per_page: 25,
        status: [ClientsInvitationStatus.PENDING],
      }).then(({ invitations, paging }) => ({
        data: invitations,
        paging,
      })),
    enabled: hasWorkspaceContext,
  });
};
